import React from "react";
import { useNavigate } from "react-router-dom";
const Logout = () => {
  const navigate = useNavigate();
  const signout = () => {
    localStorage.removeItem("Name");
    localStorage.removeItem("userCode");
    localStorage.removeItem("token");
    navigate("/login");
  };
  return (
    <div>
      <li>
        <button className="dropdown-item" onClick={signout}>
          Logout
        </button>
      </li>
    </div>
  );
};

export default Logout;
